import type { DvmPopupBlock } from '../../../chart-components/dvm-popup/dvm-popup.component';
import type { DashboardTile } from '../../dvm-layout-builder/dvm-layout-builder.types';

/**
 * Fill the `table` blocks of every POPUP tile (also inside group cards) that
 * read from `dataset` but have no rows yet — called once that dataset's rows
 * arrive. Returns the new tile list, or null when nothing changed.
 */
export function refreshPopupTilesForDataset(
  tiles: DashboardTile[],
  dataset: string,
  rowsAll: Array<Record<string, unknown>>,
): DashboardTile[] | null {
  if (!dataset) return null;
  let changed = false;
  const refresh = (tile: DashboardTile): DashboardTile => {
    if (tile.layoutType === 'GROUP' && tile.groupMembers) {
      return { ...tile, groupMembers: tile.groupMembers.map(refresh) };
    }
    if (!tile.popupControl) return tile;
    const blocks = (tile.popupControl.widgetData['blocks'] as DvmPopupBlock[] | undefined) ?? [];
    if (!blocks.some((block) => block.type === 'table' && block.dataset === dataset && !(block.rows?.length))) return tile;
    const nextBlocks = blocks.map((block) => {
      if (block.type !== 'table' || block.dataset !== dataset || block.rows?.length) return block;
      const columns = block.columns?.length ? block.columns : (rowsAll[0] ? Object.keys(rowsAll[0]) : []);
      const max = block.maxRows && block.maxRows > 0 ? block.maxRows : 50;
      const rows = rowsAll.slice(0, max).map((row) => {
        const out: Record<string, unknown> = {};
        columns.forEach((column) => { out[column] = row[column]; });
        return out;
      });
      return { ...block, columns, rows };
    });
    changed = true;
    return { ...tile, popupControl: { widgetData: { ...tile.popupControl.widgetData, blocks: nextBlocks } } };
  };
  const next = tiles.map(refresh);
  return changed ? next : null;
}
